import { TopicGraphNodeData } from './types';

export type TopicNodeLockContext = Pick<TopicGraphNodeData, 'type' | 'metrics' | 'isQuestionTrigger'>;

const LOCKED_NODE_TYPES = new Set(['SMS_CONTACT', 'EMAIL_CONTACT']);

export const isTopicNodeInherentlyLocked = (node: TopicNodeLockContext): boolean =>
  LOCKED_NODE_TYPES.has(node.type) || node.metrics.length > 0 || node.isQuestionTrigger;

export const isTopicNodeLockedForUser = (node: TopicNodeLockContext, isSysAdmin: boolean): boolean =>
  isTopicNodeInherentlyLocked(node) && !isSysAdmin;

export const preserveLockedNodesInPatch = (
  originalNodes: TopicGraphNodeData[],
  patchNodes: TopicGraphNodeData[],
  isSysAdmin: boolean,
): TopicGraphNodeData[] => {
  const originalByIndex = new Map(originalNodes.map((node) => [node.questionIndex, node]));
  const lockedIndices = new Set(
    originalNodes.filter((node) => isTopicNodeLockedForUser(node, isSysAdmin)).map((node) => node.questionIndex),
  );

  const result = patchNodes.map((patchNode) => {
    if (!lockedIndices.has(patchNode.questionIndex)) {
      return patchNode;
    }
    return originalByIndex.get(patchNode.questionIndex) ?? patchNode;
  });

  const patchIndices = new Set(patchNodes.map((node) => node.questionIndex));
  for (const originalNode of originalNodes) {
    if (lockedIndices.has(originalNode.questionIndex) && !patchIndices.has(originalNode.questionIndex)) {
      result.push(originalNode);
    }
  }

  return result;
};
